/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Editorial_OnlyInputs */

const en_val_editorial_only = /** @type {(inputs: Val_Editorial_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editorial Only`)
};

const es_val_editorial_only = /** @type {(inputs: Val_Editorial_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo uso editorial`)
};

const fr_val_editorial_only = /** @type {(inputs: Val_Editorial_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Éditorial uniquement`)
};

const de_val_editorial_only = /** @type {(inputs: Val_Editorial_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur für redaktionelle Zwecke`)
};

const ja_val_editorial_only = /** @type {(inputs: Val_Editorial_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エディトリアルのみ`)
};

const zh_val_editorial_only = /** @type {(inputs: Val_Editorial_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仅限编辑使用`)
};

const ar_val_editorial_only = /** @type {(inputs: Val_Editorial_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`للاستخدام التحريري فقط`)
};

const id_val_editorial_only = /** @type {(inputs: Val_Editorial_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanya Editorial`)
};

const it_val_editorial_only = /** @type {(inputs: Val_Editorial_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo per Uso Editoriale`)
};

const ru_val_editorial_only = /** @type {(inputs: Val_Editorial_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Только для редакционного использования`)
};

const pt_val_editorial_only = /** @type {(inputs: Val_Editorial_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Somente Editorial`)
};

const ko_val_editorial_only = /** @type {(inputs: Val_Editorial_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`에디토리얼 전용`)
};

/**
* | output |
* | --- |
* | "Editorial Only" |
*
* @param {Val_Editorial_OnlyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_editorial_only = /** @type {((inputs?: Val_Editorial_OnlyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Editorial_OnlyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_editorial_only(inputs)
	if (locale === "es") return es_val_editorial_only(inputs)
	if (locale === "fr") return fr_val_editorial_only(inputs)
	if (locale === "de") return de_val_editorial_only(inputs)
	if (locale === "ja") return ja_val_editorial_only(inputs)
	if (locale === "zh") return zh_val_editorial_only(inputs)
	if (locale === "ar") return ar_val_editorial_only(inputs)
	if (locale === "id") return id_val_editorial_only(inputs)
	if (locale === "it") return it_val_editorial_only(inputs)
	if (locale === "ru") return ru_val_editorial_only(inputs)
	if (locale === "pt") return pt_val_editorial_only(inputs)
	return ko_val_editorial_only(inputs)
});